import React, { Component } from "react";
import "./services.scss";
import "../../../node_modules/video-react/dist/video-react.css"; // import css
import Loader from "../../components/Loader";
import ItemCategory from "../../components/ItemCategory";
import ItemModality from "../../components/ItemModality";
import ItemContact from "../../components/ItemContact";
import * as Consts from "../common/consts";
import anime from "animejs";

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendMail: false,
      viewCv: false,
      ifeSelect: false,
      isBusy: true,
      txtLoadContact: false,
    };
    this.isBusy = true;
    this.isFirstTime = false;
  }

  onLoadedView = () => {
    this.isBusy = !this.isBusy;
    this.setState({ isBusy: this.state.isBusy });
    anime({
      targets: [".body-services"],
      duration: 1000,
      easing: "easeInQuad",
      scale: ["0", "1"],
    });
  };

  render() {
    let setData = Consts.setServices;
    let setDataOne = [];
    let setDataTwo = [];
    setData = setData.map((itm) => {
      return (
        <ItemCategory
          description={itm.description}
          title={itm.title}
          imageMod={itm.image}
        />
      );
    });
    setDataOne = setData.slice(0, 4);
    setDataTwo = setData.slice(4, setData.length);

    return this.isBusy ? (
      <Loader required={false} timeLoad={1000} onLoaded={this.onLoadedView} />
    ) : (
      <section className={"body-services"}>
        <div className={"cnt-categories"}>
          {setDataOne}
          {setDataTwo}
        </div>
        <div className={"cnt-column2"}>
          <ItemContact
            type={1}
            widgetMain={
              <ItemModality
                clasCustA={"cur-na"}
                clasCust={"ic-main-sel-serv"}
                title={"Services"}
                size={"x2"}
                imageMod={require("../../rsc/assets/iconServices.svg")}
              />
            }
          />
        </div>
        
      </section>
    );
  }

  onShowCv = () => {
    if (this.cvElm) {
      this.cvElm.scrollTop = this.cvElm.scrollHeight;
    }
    this.setState({
      viewCv: !this.state.viewCv,
      infoContact: "Gaviria IT Services",
    });
  };

  sendMail = () => {
    window.open("mailto:cristian@gaviria.org");
    this.setState({
      infoContact: "cristian@gaviria.org",
    });
  };
}

export default Services;
